function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import Dialog from 'rmc-dialog';
import cx from 'classnames';
var clsPrefix = 'tcpc-modal';
var clsWrapName = 'tcpc-modal-wrap';

var Modal = function Modal(props) {
  var _cx;

  var description = props.description,
      style = props.style,
      restProps = props.restProps,
      className = props.className,
      afterClose = props.afterClose,
      maskClosable = props.maskClosable,
      children = props.children,
      visible = props.visible,
      title = props.title,
      prefixCls = props.prefixCls,
      wrapClassName = props.wrapClassName,
      onClose = props.onClose,
      closeLocation = props.closeLocation;
  var baseProps = {
    maskClosable: maskClosable,
    afterClose: afterClose,
    visible: visible,
    restProps: restProps,
    style: style,
    onClose: onClose,
    className: cx(className, (_cx = {}, _defineProperty(_cx, "".concat(clsPrefix, "-top"), closeLocation === 'top'), _defineProperty(_cx, "".concat(clsPrefix, "-default"), closeLocation === 'default'), _cx)),
    wrapClassName: cx(clsWrapName, wrapClassName),
    prefixCls: cx(clsPrefix, prefixCls)
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dialog, Object.assign({}, baseProps, {
    title: title,
    style: style
  }), /*#__PURE__*/React.createElement(React.Fragment, null, description && /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-description")
  }, description), children)));
};

Modal.defaultProps = {
  maskClosable: false,
  closeLocation: 'bottom'
};
export default /*#__PURE__*/React.memo(Modal);